import { baseApi } from "./baseApi";
import { buildPaginationQueryString } from "./queryHelpers";
import { PaginateQuery } from "../../interfaces";
import {
  CreateFlashCardV2Request,
  FlashCardV2Dto,
  UpdateFlashCardV2Request,
} from "../../interfaces/flash-card-v2";
import { Paginated } from "../../models";

export const flashCardV2Api = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getFlashCardsV2: builder.query<
      Paginated<FlashCardV2Dto>,
      { data: PaginateQuery; lessonId: string }
    >({
      query: ({ data, lessonId }) => ({
        url: buildPaginationQueryString(
          data,
          `/api/v2/flash-card/${lessonId}/lesson`,
        ),
      }),
      providesTags: ["Paginated-Flash-Cards"],
    }),
    getFlashCardV2: builder.query<FlashCardV2Dto, string>({
      query: (id) => ({ url: `/api/v2/flash-card/${id}` }),
      providesTags: ["FlashCard"],
    }),
    addFlashCardV2: builder.mutation<
      any,
      { lessonId: string; data: CreateFlashCardV2Request }
    >({
      query: ({ lessonId, data }) => ({
        url: `/api/v2/flash-card/${lessonId}/lesson`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Paginated-Flash-Cards", "Chapter-Flash-Card-Stats"],
    }),
    updateFlashCardV2: builder.mutation<
      any,
      { id: string; data: UpdateFlashCardV2Request }
    >({
      query: ({ id, data }) => ({
        url: `/api/v2/flash-card/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["Paginated-Flash-Cards", "FlashCard"],
    }),
    deleteFlashCardV2: builder.mutation<any, string>({
      query: (id) => ({
        url: `/api/v2/flash-card/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Paginated-Flash-Cards", "Chapter-Flash-Card-Stats"],
    }),
    toggleFlashCardV2State: builder.mutation<any, string>({
      query: (id) => ({
        url: `/api/v2/flash-card/toggle-state/${id}`,
        method: "PATCH",
        body: {},
      }),
      invalidatesTags: ["Paginated-Flash-Cards"],
    }),
  }),
});

export const {
  useGetFlashCardsV2Query,
  useGetFlashCardV2Query,
  useAddFlashCardV2Mutation,
  useUpdateFlashCardV2Mutation,
  useDeleteFlashCardV2Mutation,
  useToggleFlashCardV2StateMutation,
} = flashCardV2Api;
